module.exports = {
          srcSet: "/_next/static/images/user6-146-3a4ca960fdf8e2139b4bd9f60f215674.jpg"+" 146w",
          images:[ {path: "/_next/static/images/user6-146-3a4ca960fdf8e2139b4bd9f60f215674.jpg",width: 146,height: 146}],
          src: "/_next/static/images/user6-146-3a4ca960fdf8e2139b4bd9f60f215674.jpg",
          toString:function(){return "/_next/static/images/user6-146-3a4ca960fdf8e2139b4bd9f60f215674.jpg"},
          
          width: 146,
          height: 146
        }